import { render, staticRenderFns } from "./TutoriaModal.vue?vue&type=template&id=1c4b1800&scoped=true"
import script from "./TutoriaModal.vue?vue&type=script&lang=js"
export * from "./TutoriaModal.vue?vue&type=script&lang=js"
import style0 from "./TutoriaModal.vue?vue&type=style&index=0&id=1c4b1800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b1800",
  null
  
)

export default component.exports